import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import Chip from '@mui/material/Chip';
import { LightChip } from '.';

export type ShiftStatusChipProps = {
  value: string;
};
export function ShiftStatusChip({ value }: ShiftStatusChipProps) {
  const colorByStatus: Record<string, ComponentProps<typeof LightChip>['color']> = {
    Opened: 'info',
    Pending: 'warning',
    Assigned: 'success',
    Canceled: 'error',
    InProgress: 'primary',
    Unfilled: 'warning',
    Deleted: 'default',
    Expired: 'default',
    Unassigned: 'warning',
    Completed: 'default',
    Reassigned: 'warning',
  };

  return (
    <Chip
      variant="filled"
      disabled={value === 'Expired'}
      color={colorByStatus[value] ?? 'default'}
      label={<FormattedMessage id={`shifts.status.${value.toLowerCase()}`} />}
      size="small"
    />
  );
}
